export const patternUF = options => {
    let array = [];

    options.forEach( option => {
        array.push({ value: option.id, label: option.nome })        
    });

    return array;
}

export default patternUF;